<template>
  <div class="horse-list">
		<table>
			<thead>
				<tr>
					<th>
						<div class="bar bg-blue">
							<h3>Name</h3>
						</div>
					</th>
					<th>
						<div class="bar bg-brown">
							<h3>Jobs</h3>
						</div>
					</th>
				</tr>
			</thead>
			<tbody>
				<tr v-for="(person, i) in people" :key="i">
					<td class="name">{{ person.name }}</td>
					<td class="job">{{ jobs[person.job_id] ? jobs[person.job_id].name : '' }}</td>
					<td class="icon history">
						<button class="button-transparent" @click="$emit('history', person)">
							<i class="ss-clock ss-glyphish-filled"></i>
						</button>
					</td>
					<td class="icon edit">
						<button class="button-transparent" @click="$emit('edit', person)">
							<i class="ss-write ss-glyphish-filled"></i>
						</button>
					</td>
					<td class="icon delete">
						<button class="button-transparent" @click="$emit('delete', person)">
							<i class="ss-trash ss-glyphish-filled"></i>
						</button>
					</td>
				</tr>
				<tr v-if="people.length === 0">
					<td colspan="6">No people found</td>
				</tr>
			</tbody>
		</table>
	</div>
</template>

<script>
export default {
	props: ['people'],
	computed: {
		jobs() {
			return this.mapArrayById(this.$store.getters['jobs/list'], 'id')
		},
	},
}
</script>

<style lang="scss">

</style>



// WEBPACK FOOTER //
// src/components/People/List.vue